import { lazy } from 'react';
import PageView from './PageView';

const NetflixInitiatedChangesPage = lazy(() => import('src/pages/netflixInitiatedChanges'));

export const netflixInitiatedChangesRoutes = [
  {
    path: 'netflix-initiated-changes',
    element: <PageView permission="BO_CAN_VIEW_NETFLIX_SYNC_REQUESTS" />,
    children: [{ element: <NetflixInitiatedChangesPage />, index: true }],
  },
];
